import styled, { css } from 'styled-components'

export const Content = styled.div<{ $hasPaddings: boolean }>`
  ${(p) =>
    p.$hasPaddings
      ? css`
          padding: 28px 50px;
        `
      : ``}
`
